import { chips } from '@/common/components/SelectedFilters/constants'

export const getChipsData = (filters, context, isFilterValid) =>
  filters.flatMap(filter => {
    if (!filter.type || !isFilterValid(filter)) return []
    const chip = chips.find(c => c.show(filter.value))
    if (!chip) return []

    return [{ filter, Icon: chip.Icon, label: chip.label({ filters: filter.value, ...context }) }]
  })
